module.exports = __webpack_public_path__ + "img/merso-icon.6d0e438b.png";